module.exports = __webpack_public_path__ + "static/media/image-not-found-1038x576.12293d01.jpg";